// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"161":"component---src-pages-recommendations-tsx","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] || chunkId) + "-" + {"161":"acdd94a7d83dd7756ec9","245":"bfe24ba95b52919fd2a5","453":"b3075a5afa40f930f1af","812":"23640097eb5fd5782784"}[chunkId] + ".js";
};